import React, { useState } from "react";
import CountrySelector from "./CountrySelector";
import StateSelector from "./StateSelector";

const CountryStateFilter = ({ onCountryChange, onStateChange }) => {
  const [countryId, setCountryId] = useState("");
  const [stateId, setStateId] = useState("");

  const handleCountrySelect = (selectedCountryId) => {
    setCountryId(selectedCountryId);
    setStateId(""); // Reset state when country changes
    onCountryChange(selectedCountryId);
  };

  const handleStateSelect = (selectedStateId) => {
    setStateId(selectedStateId);
    onStateChange(selectedStateId);
  };

  return (
    <div>
      <CountrySelector
        currentCountry={countryId}
        onSelectCountryCallback={handleCountrySelect}
      />
      <StateSelector
        currentState={stateId}
        countryId={countryId}
        onSelectStateCallback={handleStateSelect}
      />
    </div>
  );
};

export default CountryStateFilter;
